var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplicaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.6 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f,.g{fill:#fff;}.g{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M30.1,41.4V18.8C30.1,0,18.8,0,18.8,0c0,0-11.3,0-11.3,18.8v22.6s-7.5,0-7.5,22.6c0,0,9-8.9,16.2-10.9,0,2.2,1.2,4,2.6,4s2.6-1.8,2.6-4c7.3,2,16.2,10.9,16.2,10.9,0-22.6-7.5-22.6-7.5-22.6ZM18.8,3.8c1,0,6.3,1,7.3,11.3H11.5c1.1-10.3,6.4-11.2,7.3-11.3Zm0,45.2c-4.8,0-10.3,3.3-14.6,6.5,1-8,3.2-9.9,3.7-10.2h3.3V18.8h15.1v26.4h3.3c.5,.3,2.7,2.2,3.7,10.2-4.3-3.2-9.8-6.5-14.6-6.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M85.1,41.4V18.8C85.1,0,73.8,0,73.8,0c0,0-11.3,0-11.3,18.8v22.6s-7.5,0-7.5,22.6c0,0,9-8.9,16.2-10.9,0,2.2,1.2,4,2.6,4s2.6-1.8,2.6-4c7.3,2,16.2,10.9,16.2,10.9,0-22.6-7.5-22.6-7.5-22.6ZM73.8,3.8c1,0,6.3,1,7.3,11.3h-14.7c1.1-10.3,6.4-11.2,7.3-11.3Zm0,45.2c-4.8,0-10.3,3.3-14.6,6.5,1-8,3.2-9.9,3.7-10.2h3.3V18.8h15.1v26.4h3.3c.5,.3,2.7,2.2,3.7,10.2-4.3-3.2-9.8-6.5-14.6-6.5Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "g",
    d: "M52.1,25.3l1.7,1.8c.4,.4,0,1-.4,1h-18.3c-.7,0-1,.5-1,1.2h0c0,.7,.3,1.2,1,1.2h18.3c.5,0,.8,.7,.4,1l-1.7,1.8c-.5,.5-.4,1.3,0,1.7h0c.5,.5,1.3,.4,1.7,0l3.9-4.1c.9-.9,.9-2.4,0-3.4l-3.9-4c-.5-.5-1.2-.5-1.7,0h0c-.5,.5-.5,1.2,0,1.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplicaIcon);
export default __webpack_public_path__ + "static/media/replica-icon.7155db420f05e993f43939faca845c0a.svg";
export { ForwardRef as ReactComponent };